<template>
    <div>
        <multiselect v-model="DisplayValue" :options="options" :multiple="false" track-by="name" :clear-on-select="false" :show-labels="false" label="name" :preselect-first="true">
            <p slot="noResult" class="text-danger"> Oops! No Tax Rate found.</p>
            <span slot="noResult" class="btn btn-primary btn-round" v-on:click="AddTax('Add')">Create new Tax Rate</span><br />
        </multiselect>
        <modal :show="show" v-if="show">
            <div style="margin-bottom:0px" class="card">
                <div class="card-body">
                    <div class="col-lg-12">
                        <div class="tab-content" id="nav-tabContent">
                            <div class="modal-header" v-if="type=='Edit'">

                                <h5 class="modal-title" id="myModalLabel"> Update TaxRate</h5>

                            </div>
                            <div class="modal-header" v-else>

                                <h5 class="modal-title" id="myModalLabel"> Add TaxRate</h5>

                            </div>
                            <div class="text-left">
                                <div class="card-body text-left">
                                    <div class="row ">
                                        <div class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.taxRate.name.$error}">
                                            <label class="text  font-weight-bolder"> TaxRate Name: *</label>
                                            <input class="form-control" v-model="$v.taxRate.name.$model" type="text" />
                                            <span v-if="$v.taxRate.name.$error" class="error">
                                                <span v-if="!$v.taxRate.name.required">TaxRate name is required</span>
                                                <span v-if="!$v.taxRate.name.maxLength">TaxRate name has maximum Length 50</span>
                                            </span>
                                        </div>
                                        <div :key="render" class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.taxRate.code.$error}">
                                            <label class="text  font-weight-bolder"> Code:</label>
                                            <input disabled class="form-control" v-model="$v.taxRate.code.$model" type="text" />
                                            <span v-if="$v.taxRate.code.$error" class="error">
                                                <span v-if="!$v.taxRate.code.maxLength">Code has maximum Length 30</span>
                                            </span>
                                        </div>
                                        <div class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.taxRate.rate.$error}">
                                            <label class="text  font-weight-bolder"> Tax Rate: *</label>
                                            <input class="form-control" v-model="$v.taxRate.rate.$model" type="number" />
                                            <span v-if="$v.taxRate.rate.$error" class="error">
                                                <span v-if="!$v.taxRate.rate.required">Rate is required</span>
                                                <span v-if="!$v.taxRate.rate.maxLength">Rate  has maximum Length 10</span>
                                            </span>
                                        </div>

                                        <div class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.taxRate.description.$error}">
                                            <label class="text  font-weight-bolder"> Description: </label>
                                            <textarea class="form-control" v-model="$v.taxRate.description.$model" type="text" />
                                            <span v-if="$v.taxRate.description.$error" class="error">Description have max Length 200</span>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label style="margin: 7px;">Active</label> <br />
                                            <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" v-bind:class="{'bootstrap-switch-on': taxRate.isActive, 'bootstrap-switch-off': !taxRate.isActive}" v-on:click="taxRate.isActive = !taxRate.isActive" style="width: 72px;">
                                                <div class="bootstrap-switch-container" style="width: 122px; margin-left: 0px;">
                                                    <span class="bootstrap-switch-handle-on bootstrap-switch-success" style="width: 50px;">
                                                        <i class="nc-icon nc-check-2"></i>
                                                    </span>
                                                    <span class="bootstrap-switch-label" style="width: 30px;">&nbsp;</span>
                                                    <span class="bootstrap-switch-handle-off bootstrap-switch-success" style="width: 50px;">
                                                        <i class="nc-icon nc-simple-remove"></i>
                                                    </span>
                                                    <input class="bootstrap-switch" type="checkbox" data-toggle="switch" checked="" data-on-label="<i class='nc-icon nc-check-2'></i>" data-off-label="<i class='nc-icon nc-simple-remove'></i>" data-on-color="success" data-off-color="success">
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer justify-content-right" v-if="type=='Edit'">

                                <button type="button" class="btn btn-primary btn-round " v-on:click="SaveTaxRate" v-bind:disabled="$v.taxRate.$invalid"> Update</button>
                                <button type="button" class="btn btn-secondary btn-round mr-3 " v-on:click="close()">Cancel</button>

                            </div>
                            <div class="modal-footer justify-content-right" v-else>

                                <button type="button" class="btn btn-primary btn-round " v-on:click="SaveTaxRate" v-bind:disabled="$v.taxRate.$invalid"> Save</button>
                                <button type="button" class="btn btn-secondary btn-round mr-3 " v-on:click="close()">Cancel</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
export default {
  name: "taxratedropdown",
  props: ["values"],

        components: {
            Multiselect,
            
        },
        data: function () {
            return {
                options: [],
                value: '',
                show: false,
                type: '',
                taxRate: {
                    id: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    name: '',
                    description: ''
                },
                render: 0
            }
        },
        methods: {
            getData: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                 
                this.$https.get('/Product/TaxRateList', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    
                     
                    if (response.data != null) {
                        response.data.taxRates.forEach(function (cat) {
                             
                            root.options.push({
                                id: cat.id,
                                name: cat.name
                            })
                       })
                    }
                }).then(function () {
                    root.value = root.options.find(function (x) {
                        return x.id == root.values;
                    })
                });
            },
            AddTax: function (type) {
                this.GetAutoCodeGenerator();
                this.taxRate = {
                    id: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    name: '',
                    description: ''
                }

                this.show = !this.show;
                this.type = type;
            },
            close: function () {
                this.$emit('close');
            },
            GetAutoCodeGenerator: function () {
                 //eslint-disable-line
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.get('/Product/TaxRateCode', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                     //eslint-disable-line
                    if (response.data != null) {
                        root.taxRate.code = response.data;
                        root.render++;
                    }
                });
            },
            SaveTaxRate: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.post('/Product/SaveTaxRate', this.taxRate, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data.isSuccess == true) {
                        if (root.type != "Edit") {
                            root.$store.state.taxRateList.push({
                                id: response.data.taxRate.id,
                                name: response.data.taxRate.name,
                                rate: response.data.taxRate.rate,
                                description: response.data.taxRate.description,
                                code: response.data.taxRate.code,
                            })
                            root.loading = false
                            root.options.push({
                                id : response.data.id,
                                code : root.taxRate.code,
                                name : root.taxRate.name,
                                description: root.taxRate.description
                            })
                            root.show = false;
                        }
                        else {
                            var data = root.$store.state.taxRateList.find(function (x) {
                                return x.id == response.data.taxRate.id;
                            });
                            data.id = response.data.taxRate.id;
                            data.name = response.data.taxRate.name;
                            data.rate = response.data.taxRate.rate;
                            data.description = response.data.taxRate.description;
                            data.code = response.data.taxRate.code;
                            root.$swal({
                                title: "Update!",
                                text: "Your TaxRate " + response.data.taxRate.name + " has been updated!",
                                type: 'success',
                                icon:'success',
                             
                                showConfirmButton: false,
                                timer: 800,
                                timerProgressBar: true,

                            });
                            root.close();
                        }
                    }
                    else {
                        root.$swal({
                            title: "Error!",
                            text: "Your TaxRate Name  Already Exist!",
                            type: 'error',
                            icon:'error',
                           
                            showConfirmButton: false,
                            timer: 800,
                            timerProgressBar: true,

                        });
                    }
                });
            }
        },
        computed: {
            DisplayValue: {
                get: function () {
                    if (this.value != "" || this.value != undefined) {
                        return this.value;
                    }
                    return this.values;
                },
                set: function (value) {
                    this.value = value;
                    this.$emit('input', value.id);
                }
            }
        },
        mounted: function () {
            this.getData();
        },
    }
</script>